import $http from '@Config/axios';

const prefix = 'vias-de-administracao';

export const RouteAdministrationPresenter = {
	findAll: () => $http.get(`${prefix}`)
};
